<template>
  <m-card901 :image="content.thumbnail" :alt="content.title">
    <template #p-1>
      <m-a class="text-decoration-none" :href="findLinkOnContent(content.abstraction)">
        <h1>{{ content.title }}</h1>
      </m-a>
    </template>
    <template #p-2>
      <div class="" v-html="content.body"></div>
    </template>
    <template #p-3>
      <m-button902 class="m-1" v-for="keyword in content.keywords">{{ keyword.keyword }}</m-button902>
    </template>
    <template #p-4>
      <m-a :href="findLinkOnContent(content.abstraction)">
        <m-button301 class="bg-primary m-3">
          مشاهده
        </m-button301>
      </m-a>
    </template>
  </m-card901>
</template>

<script>
import mCard901 from "../../Cards/Card901";
import mA from "../../Tags/A";
import mButton301 from "../../Buttons/Button301";
import mButton902 from "../../Buttons/Button902";

export default {
  name: "ContentCard901",
  components: {mCard901, mA, mButton301, mButton902},
  props: {
    content: {}
  }
}
</script>

<style scoped>

</style>